export const fireplaceClasses = [
    'B11', 'B11AS', 'B11BS', 'B12',
    'B12AS', 'B12BS', 'B13', 'B13AS',
    'B13BS', 'B14', 'B14AS', 'B14BS',
    'B21', 'B22', 'B22P', 'B22D',
    'B23', 'B23P', 'B23D', 'B31',
    'B32', 'B33', 'B41', 'B42',
    'B43', 'B44', 'B44P', 'B51',
    'B52', 'B52P', 'B52S', 'B53',
    'B53P', 'B53S'
]
